(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbd-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nbd-details')) {
    customElements.define('nbd-details', class NBDDetails extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.details.addEventListener('toggle', () => {
          this.dispatchEvent(new CustomEvent('nbd:details-toggle', {
            detail: { open: this.details.open },
            bubbles: true,
            composed: true,
          }));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nbd-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nbd-dialog')) {
    customElements.define('nbd-dialog', class NBDDialog extends HTMLElement {
      static count = 0;

      constructor() {
        super();
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.handleDialogClick = this.handleDialogClick.bind(this);
      }

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.labelDialog();
        const id = this.dataset.id;
        const selector = id
          ? `[data-nbd-open-dialog=""], [data-nbd-open-dialog="${CSS.escape(id)}"]`
          : '[data-nbd-open-dialog=""]';
        this.openButtons = document.querySelectorAll(selector);
        this.openButtons.forEach((button) => {
          button.setAttribute('aria-haspopup', 'dialog');
          button.addEventListener('click', this.handleOpenClick);
        });
        this.dialog.addEventListener('click', this.handleDialogClick);
      }

      disconnectedCallback() {
        this.openButtons.forEach((button) => button.removeEventListener('click', this.handleOpenClick));
        this.dialog.removeEventListener('click', this.handleDialogClick);
      }

      labelDialog() {
        const title = this.querySelector('.nbd-dialog-header-title');
        if (!title?.textContent.trim() || this.dialog.hasAttribute('aria-labelledby')) return;
        title.id ||= `nbd-dialog-title-${++NBDDialog.count}`;
        this.dialog.setAttribute('aria-labelledby', title.id);
      }

      handleOpenClick() {
        this.dialog.showModal();
      }

      handleDialogClick(event) {
        if (event.target.closest('[data-nbd-close-dialog]')) {
          this.dialog.close();
          return;
        }
        if (event.target !== this.dialog) return;
        // The dialog itself is the target for clicks on empty panel space too, so check the click landed outside the panel.
        const rect = this.dialog.getBoundingClientRect();
        const inside = event.clientX >= rect.left && event.clientX <= rect.right
          && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nbd-swatch"] && !Shopify.designMode) return;
  try {
    NBD.onLoad(() => {
    if (customElements.get('nbd-swatch')) return;

    class NBDSwatch extends HTMLElement {
      constructor() {
        super();
        this.max = 512;
        this.ttl = 5 * 60 * 1000;
        this.handle = this.dataset.handle;
        // Availability differs by market, so cache per country.
        this.key = `${window.Shopify?.country || ''}:${this.handle}`;
      }

      connectedCallback() {
        this.render();
      }

      productUrl(handle) {
        const base = window.Shopify?.routes?.root || '/';
        return `${base}products/${handle}`;
      }

      update(ok) {
        this.toggleAttribute('data-show', ok);
        this.toggleAttribute('data-hide', !ok);
      }

      async render() {
        this.store = NBD.cache('Swatch', this.max);

        if (this.store.has(this.key)) {
          this.update(this.store.get(this.key));
          return;
        }

        try {
          const res = await fetch(this.productUrl(this.handle), { method: 'HEAD' });
          // Only a definite answer is cached; other errors may be transient.
          if (res.ok || res.status === 404) {
            this.store.put(this.key, res.ok, this.ttl);
          }
          this.update(res.ok);
        } catch {
          this.update(false);
        }
      }
    }

    customElements.define('nbd-swatch', NBDSwatch);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nbd-table-of-contents"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nbd-table-of-contents')) {
    customElements.define('nbd-table-of-contents', class NBDTableOfContents extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.nbd-table-of-contents-nav');
        this.sections = [...this.querySelectorAll('.nbd-table-of-contents-sections section[id]')];
        if (this.sections.length === 0) return;

        this.links = new Map();
        this.visible = new Set();
        this.nav.replaceChildren(this.buildList());

        this.observer = new IntersectionObserver((entries) => this.onIntersect(entries));
        this.sections.forEach((section) => this.observer.observe(section));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      buildList() {
        const list = document.createElement('ul');
        this.sections.forEach((section) => {
          const link = document.createElement('a');
          link.href = `#${section.id}`;
          link.textContent = section.dataset.tocTitle || section.querySelector('h2,h3,h4,h5,h6')?.textContent.trim() || 'Section';
          const item = document.createElement('li');
          item.append(link);
          list.append(item);
          this.links.set(section, link);
        });
        return list;
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.visible.add(entry.target);
          } else {
            this.visible.delete(entry.target);
          }
        });
        const current = this.sections.find((section) => this.visible.has(section));
        this.links.forEach((link, section) => {
          if (section === current) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
